import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FinraFormsService } from '@finra/forms';
import { AbstractSchemaService, AbstractSchemaServiceEnv } from '@finra/rampdi-forms-common';
import { environment } from '../../environments/environment';
import { NavigationDataService } from './navigation-data.service';

export const schemaObj_v001 = {
  identifyingInformation: {
    schema: '#/properties/identifyingInformation',
    id: 'identifyingInformation',
    title: 'Identifying Information',
  },
  webAddresses: {
    schema: '#/',
    id: 'webAddresses',
    title: 'Web Addresses',
  },
  operationInformation: {
    schema: '#/',
    id: 'operationInformation',
    title: 'Operation Information',
  },
  expenseInformation: {
    schema: '#/',
    id: 'expenseInformation',
    title: 'Expense Information',
  },
  formViewIdentifyingInformation: {
    schema: '#/',
    id: 'formViewIdentifyingInformation',
    title: 'MU3 Form',
  },
  formViewWebAddresses: {
    schema: '#/',
    id: 'formViewWebAddresses',
    title: 'MU3 Form',
  },
  formViewOperationInformation: {
    schema: '#/',
    id: 'formViewOperationInformation',
    title: 'MU3 Form',
  },
  formViewExpenseInformation: {
    schema: '#/',
    id: 'formViewExpenseInformation',
    title: 'MU3 Form',
  },
};

export const schemaObj = {
  identifyingInformation: {
    schema: '#/properties/identifyingInformation',
    id: 'identifyingInformation',
    title: 'Identifying Information',
  },
  webAddresses: {
    schema: '#/',
    id: 'webAddresses',
    title: 'Web Addresses',
  },
  operationInformation: {
    schema: '#/',
    id: 'operationInformation',
    title: 'Operation Information',
  },
  expenseInformation: {
    schema: '#/',
    id: 'expenseInformation',
    title: 'Expense Information',
  },
  formViewIdentifyingInformation: {
    schema: '#/',
    id: 'formViewIdentifyingInformation',
    title: 'MU3 Form',
  },
  formViewWebAddresses: {
    schema: '#/',
    id: 'formViewWebAddresses',
    title: 'MU3 Form',
  },
  formViewOperationInformation: {
    schema: '#/',
    id: 'formViewOperationInformation',
    title: 'MU3 Form',
  },
  formViewExpenseInformation: {
    schema: '#/',
    id: 'formViewExpenseInformation',
    title: 'MU3 Form',
  },
};

@Injectable({
  providedIn: 'root',
})
export class SchemaService extends AbstractSchemaService {
  constructor(
    navDataService: NavigationDataService,
    http: HttpClient,
    router: Router,
    route: ActivatedRoute,
    ffs: FinraFormsService,
  ) {
    super(schemaObj, navDataService, http, router, route, ffs);
  }

  resolve(route: any, state: any) {
    const { instance } = route.parent.data.instanceData;
    const templateVersion = instance?.templateVersion;

    // Use version-specific schema for 0.0.1
    if (templateVersion === '0.0.1') {
      this.schemaObj = schemaObj_v001;
    } else {
      this.schemaObj = schemaObj;
    }

    return super.resolve(route, state);
  }

  get environment(): AbstractSchemaServiceEnv {
    return environment;
  }
}
